<script setup>
import useToast from '@/Composables/app/useToast';

const { items, remove } = useToast();
</script>

<template>
  <TransitionGroup
    tag="div"
    enter-from-class="translate-x-full opacity-0"
    enter-active-class="duration-500"
    leave-active-class="duration-500"
    leave-to-class="translate-x-full opacity-0"
    class="fixed right-0 top-0 z-50 flex flex-col items-end gap-4 overflow-hidden"
    :class="[items.length > 0 && 'p-4 pb-5']"
  >
    <ToastItem
      v-for="(item, index) in items"
      :key="item.key"
      :toast="item"
      @remove="remove(index)"
    />
  </TransitionGroup>
</template>
